import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Home from './Home/Home';
import LoginPage from './Login/LoginPage';
import { Box, Spinner, Stack } from '@chakra-ui/react';

const AuthRedirect: React.FC = () => {
    const { isAuthenticated, isLoadingAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoadingAuth && !isAuthenticated) {
            navigate('/');
        }
    }, [isAuthenticated, isLoadingAuth, navigate]);

    if (isLoadingAuth) {
        return (
            <Box className="login-container">
                <Stack align="center">
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='black'
                        size='xl'
                    />
                </Stack>
            </Box>
        )
    }

    if (isAuthenticated) {
        return <Home />;
    }

    return <LoginPage />;
};

export default AuthRedirect;
